var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-empty */
/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useState, useEffect } from "react";
import "normalize.css";
import styled from "styled-components";
import { useGlobalDispatch, useGlobalState } from "../../hooks";
import { fetchCmsAppData, fetchImpersonations, fetchPasswordLink, } from "../../requests";
import { SnowDayBanner } from "./SnowDayBanner";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import { HeaderButtons } from "./HeaderButtons";
import { SearchContainer } from "./SearchContainer";
// import { useUsage } from '../../hooks/useUsage';
export var GlobalModals;
(function (GlobalModals) {
    GlobalModals["About"] = "about";
    GlobalModals["Help"] = "help";
    GlobalModals["Learning"] = "learning";
    GlobalModals["Support"] = "support";
    GlobalModals["IpsVideo"] = "ips video";
    GlobalModals["Feedback"] = "feedback";
    GlobalModals["Confirm"] = "confirm";
})(GlobalModals || (GlobalModals = {}));
export function Header(_a) {
    var productName = _a.productName, productLogo = _a.productLogo, darkModeLogo = _a.darkModeLogo, _b = _a.logoLink, logoLink = _b === void 0 ? "/" : _b, _c = _a.showSearch, showSearch = _c === void 0 ? true : _c, _d = _a.showAppMenu, showAppMenu = _d === void 0 ? true : _d, _e = _a.showSupport, showSupport = _e === void 0 ? true : _e, dropdownSpacer = _a.dropdownSpacer, _f = _a.showVideo, showVideo = _f === void 0 ? true : _f, cmsCourseId = _a.cmsCourseId, _g = _a.faqFolders, faqFolders = _g === void 0 ? [] : _g, _h = _a.overrideSearch, overrideSearch = _h === void 0 ? false : _h, _j = _a.setIsSearching, setIsSearching = _j === void 0 ? function (fill) { } : _j, _k = _a.isSearching, isSearching = _k === void 0 ? false : _k, _l = _a.searchValue, searchValue = _l === void 0 ? "" : _l, _m = _a.setSearchValue, setSearchValue = _m === void 0 ? function (fill) { } : _m, _o = _a.onSearchSubmit, onSearchSubmit = _o === void 0 ? function () { } : _o;
    var global = useGlobalState();
    var _p = useState(null), qMarkData = _p[0], setQMarkData = _p[1];
    var _q = useState(null), snowDayData = _q[0], setSnowDayData = _q[1];
    var globalDispatch = useGlobalDispatch();
    var _r = useState([]), impersonations = _r[0], setImpersonations = _r[1];
    var _s = useState(productLogo), logo = _s[0], setLogo = _s[1];
    var _t = useState(""), headerLogo = _t[0], setHeaderLogo = _t[1];
    var _u = useState(), video = _u[0], setVideo = _u[1];
    useEffect(function () {
        getAndSetQMarkData();
        getAndSetImpersonations();
        var cleanupFunction = updateFavicon();
        return cleanupFunction;
    }, []);
    useEffect(function () {
        fetchCmsPasswordLink();
    }, []);
    // useUsage();
    useEffect(function () {
        if (video) {
            globalDispatch({
                type: "set video",
                payload: {
                    showOnNeverSeen: showVideo,
                    source: video.source,
                    name: video.name,
                    title: video.title,
                    subtitle: video.subtitle,
                },
            });
        }
    }, [video]);
    // prevent background scrolling when on the network search route
    var location = useLocation();
    useEffect(function () {
        if (((location === null || location === void 0 ? void 0 : location.pathname) || "").includes("network-search")) {
            document.body.style.overflow = "hidden";
        }
        else {
            document.body.style.overflow = "unset";
        }
    }, [location]);
    function updateFavicon() {
        var matcher = window.matchMedia("(prefers-color-scheme: dark)");
        if (!matcher || !(matcher === null || matcher === void 0 ? void 0 : matcher.addEventListener))
            return;
        function onUpdate() {
            if (matcher && matcher.matches) {
                setLogo(darkModeLogo);
            }
            else {
                setLogo(productLogo);
            }
        }
        onUpdate();
        matcher.addEventListener("change", onUpdate);
        return function () {
            matcher.removeEventListener("change", onUpdate);
        };
    }
    function fetchCmsPasswordLink() {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, fetchPasswordLink()];
                    case 1:
                        data = _b.sent();
                        globalDispatch({
                            type: "changepassword",
                            payload: ((_a = data.ipsIntro) === null || _a === void 0 ? void 0 : _a.PasswordLink) || "",
                        });
                        return [2 /*return*/];
                }
            });
        });
    }
    function getAndSetQMarkData() {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var data, closedBefore, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        if (!cmsCourseId)
                            return [2 /*return*/];
                        return [4 /*yield*/, fetchCmsAppData(cmsCourseId)];
                    case 1:
                        data = _b.sent();
                        updateVideo(data);
                        setQMarkData(data.worldApp);
                        closedBefore = !!localStorage.getItem("sdm" + btoa(((_a = data.snowDayBanner) === null || _a === void 0 ? void 0 : _a.Message) || "1234"));
                        if (closedBefore)
                            return [2 /*return*/];
                        setSnowDayData(data.snowDayBanner);
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _b.sent();
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    function updateVideo(data) {
        var defaultVideo = data.defaultWorldSetting.defaultVideo;
        var appData = data.worldApp;
        if ((appData === null || appData === void 0 ? void 0 : appData.video) && (appData === null || appData === void 0 ? void 0 : appData.video.hlsUrl) && appData.videoName) {
            var appVideo = {
                source: appData === null || appData === void 0 ? void 0 : appData.video.hlsUrl,
                name: appData.videoName,
                title: appData.title,
                subtitle: appData.subtitle,
            };
            setVideo(appVideo);
        }
        else {
            setVideo({
                source: defaultVideo.video.hlsUrl,
                name: defaultVideo.videoName,
                title: defaultVideo.title,
                subtitle: defaultVideo.subtitle,
            });
        }
    }
    // handle if should show start video
    var _v = useState(false), initVideoSet = _v[0], setInitVideoSet = _v[1];
    useEffect(function () {
        if (!initVideoSet && showVideo && global.video.views) {
            if (video &&
                !global.video.views.find(function (v) { return v.videoName === video.name; })) {
                setInitVideoSet(true);
                globalDispatch({
                    type: "set modal active",
                    payload: { modal: GlobalModals.IpsVideo },
                });
            }
        }
    }, [global.video.views]);
    function getAndSetImpersonations() {
        return __awaiter(this, void 0, void 0, function () {
            var impersonations;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetchImpersonations()];
                    case 1:
                        impersonations = _a.sent();
                        setImpersonations(impersonations);
                        return [2 /*return*/];
                }
            });
        });
    }
    useEffect(function () {
        var gql = String;
        fetch("https://cms.evipscloud.com/graphql", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                query: gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n          {\n            commonHeaderFooter {\n              headerCentralLogo {\n                url\n              }\n              commonFooterLogo {\n                url\n              }\n            }\n          }\n        "], ["\n          {\n            commonHeaderFooter {\n              headerCentralLogo {\n                url\n              }\n              commonFooterLogo {\n                url\n              }\n            }\n          }\n        "]))),
            }),
        })
            .then(function (res) { return res.json(); })
            .then(function (res) {
            setHeaderLogo(res.data.commonHeaderFooter.headerCentralLogo.url);
        });
    });
    if (isSearching) {
        return (_jsx(Container, __assign({ showAppMenu: showAppMenu }, { children: _jsx("div", __assign({ className: "width-container" }, { children: _jsx(SearchContainer, { setIsSearching: setIsSearching, onChange: setSearchValue, searchValue: searchValue, onSubmit: onSearchSubmit }, void 0) }), void 0) }), void 0));
    }
    return (_jsxs(React.Fragment, { children: [_jsx(Helmet, { children: _jsx("link", { rel: "shortcut icon", href: logo }, void 0) }, void 0),
            _jsx(SnowDayBanner, { data: snowDayData, close: function () {
                    localStorage.setItem("sdm" + btoa((snowDayData === null || snowDayData === void 0 ? void 0 : snowDayData.Message) || "1234"), Date.now().toString());
                    setSnowDayData(snowDayData ? __assign(__assign({}, snowDayData), { Active: false }) : null);
                } }, void 0),
            _jsx(Container, __assign({ showAppMenu: showAppMenu }, { children: _jsxs("div", __assign({ className: "width-container header-layout full-width" }, { children: [_jsxs("div", __assign({ id: "logo-name-container" }, { children: [_jsx("a", __assign({ href: logoLink }, { children: _jsx("img", { src: productLogo, alt: "logo" }, void 0) }), void 0),
                                _jsx("h1", { children: productName }, void 0)] }), void 0),
                        _jsx("img", { id: "ev-logo", src: headerLogo }, void 0),
                        _jsx(HeaderButtons, { impersonations: impersonations, dropdownSpacer: dropdownSpacer, showSearch: showSearch, showSupport: showSupport, qMarkData: qMarkData, showAppMenu: showAppMenu, productName: productName, faqFolders: faqFolders, overrideSearch: overrideSearch, setIsSearching: setIsSearching }, void 0)] }), void 0) }), void 0)] }, void 0));
}
// make width always 100% and have padding left and right 24px
//  group all icons to the right
var Container = styled.header(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  height: 56px;\n  border-bottom: 3px solid var(--ev-red);\n  position: sticky;\n  top: -1px;\n  background-color: white;\n  z-index: 999;\n\n  .width-container {\n    box-sizing: border-box;\n    padding: 0 24px;\n    width: 100%;\n    height: 100%;\n\n    &.header-layout {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n    }\n  }\n\n  #logo-name-container {\n    display: flex;\n    align-items: center;\n    img {\n      width: 32px;\n      height: 32px;\n    }\n    h1 {\n      margin-left: 16px;\n      white-space: nowrap;\n      font-size: 16px;\n      font-weight: 300;\n      font-stretch: normal;\n      font-style: normal;\n      line-height: 1.2;\n      letter-spacing: 0.01px;\n      color: #666666;\n      @media (max-width: 830px) {\n        display: none;\n      }\n    }\n  }\n  #ev-logo {\n    position: absolute;\n    transform: translate(-50%, -50%);\n    left: 50%;\n    top: 50%;\n    width: 195px;\n    @media (max-width: 800px) {\n      display: none;\n    }\n  }\n"], ["\n  height: 56px;\n  border-bottom: 3px solid var(--ev-red);\n  position: sticky;\n  top: -1px;\n  background-color: white;\n  z-index: 999;\n\n  .width-container {\n    box-sizing: border-box;\n    padding: 0 24px;\n    width: 100%;\n    height: 100%;\n\n    &.header-layout {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n    }\n  }\n\n  #logo-name-container {\n    display: flex;\n    align-items: center;\n    img {\n      width: 32px;\n      height: 32px;\n    }\n    h1 {\n      margin-left: 16px;\n      white-space: nowrap;\n      font-size: 16px;\n      font-weight: 300;\n      font-stretch: normal;\n      font-style: normal;\n      line-height: 1.2;\n      letter-spacing: 0.01px;\n      color: #666666;\n      @media (max-width: 830px) {\n        display: none;\n      }\n    }\n  }\n  #ev-logo {\n    position: absolute;\n    transform: translate(-50%, -50%);\n    left: 50%;\n    top: 50%;\n    width: 195px;\n    @media (max-width: 800px) {\n      display: none;\n    }\n  }\n"])));
var templateObject_1, templateObject_2;
